import { getValidDate, getRoundIntegerNum } from '@gp/utils/common';
import { ECHART_COLOR } from '@gp/constants/const';
import { getFixedFieldColor } from '@gp/pages/StudioDashboard/StudioOverall/Tabs/People/Details/utils/common';
import { BASE_ECHART_OPTION, BASE_BAR_SERIES_OPTION } from '@gp/constants/echarts';

const getEChartOpt = (data: orgHeadcountsDataTypes, type: HeadcountsDataType) => {
  const xAxisLabelList: string[] = []; // x轴刻度名列表
  const targetMetrics = data?.metrics || [], targetData = data?.dataList || [];
  const _series = [];
  if (Array.isArray(targetMetrics) && targetMetrics?.length) {
    for (let i = 0; i < targetMetrics?.length; i ++) {
      const t: string = targetMetrics?.[i];
      const dataList: {value: string | null, data: {[key: string]: string} | null}[] = []; // 每个指标每个刻度的数据
      for (let j = 0; j < targetData?.length; j ++) {
        const k: {[key: string]: string} = targetData?.[j];
        i === 0 && xAxisLabelList?.push(getValidDate(k?.['date'], 'YYYY'));
        dataList.push({
          value: k?.[t] || null,
          data: k || null,
        });
      }
      const itemColor = getFixedFieldColor(t) || ECHART_COLOR[3 + i];
      _series.push({
        ...BASE_BAR_SERIES_OPTION,
        name: t,
        type: 'bar',
        stack: 'metric',
        barMaxWidth: 64,
        barGap: 0,
        data: dataList,
        /* emphasis: {
          focus: 'series',
        }, */
        label: {
          distance: 100,
        },
        itemStyle: {
          color: itemColor,
        },
      });
    }
  }

  return {
    ...BASE_ECHART_OPTION,
    // color: ECHART_COLOR,
    title: {
      show: false,
    },
    grid: {
      ...BASE_ECHART_OPTION.grid,
    },
    legend: {
      ...BASE_ECHART_OPTION.legend,
    },
    xAxis: {
      ...BASE_ECHART_OPTION.xAxis,
      show: true,
      type: 'category',
      data: xAxisLabelList,
      axisLabel: { // 刻度文案设置
        ...BASE_ECHART_OPTION.xAxis?.axisLabel,
        margin: 16,
      },
    },
    yAxis: [
      {
        ...BASE_ECHART_OPTION.yAxis?.[0],
        type: 'value',
        axisLabel: { // 刻度文案设置
          ...BASE_ECHART_OPTION.yAxis?.[0]?.axisLabel,
          formatter: (v: any) => getRoundIntegerNum(v),
        },
        // minInterval: 5,
        // maxInterval: 5,
        // interval: 5,
      },
    ],
    series: _series,
  };
}

// tooltip浮窗内容
const tootipFormatter = (params: any) => {
  let name = '',
     // 第一列名称
    firItemListStr = `
    <div class="header-flex  margin-10">
      <div>Total</div>
    </div>
  `,
// 第二列数据
secItemListStr = `<div class="body-num  margin-10">${getRoundIntegerNum(params?.[0]?.data?.data?.total)}</div>`;

  const paramsLen: number = params?.length || 0;
  if (Array.isArray(params) && paramsLen) {
    for (let i = 0; i < paramsLen; i ++) {
      const t = params?.[i];
      if (!name) name = getValidDate(t?.data?.data?.date, 'YYYY');
      firItemListStr += `
        <div class="dbg-flex  margin-10">
          <span class='general-circular-dot' style="background-color: ${t?.color};"></span>
          <div>${t?.seriesName}</div>
        </div>
      `;
      secItemListStr += `<div class='body-num  margin-10'>${getRoundIntegerNum(t?.value)}</div>`;
    }
  }

  const htmlStr = `
  <section class='echart-tooltip-style-content'>
    <div class="header-flex">
      <div style="margin-right: 20px">
        <div class="margin-10">${name || '-'}</div>
        <div class="header-title">
          ${firItemListStr || '-'}
        </div>
      </div>
      <div style="">
        <div class="margin-10">&nbsp;</div>
        <div>
          ${secItemListStr || '-'}
        </div>
      </div>
    </div>
  <section>
  `;
  return htmlStr;
}

export {
  getEChartOpt,
  tootipFormatter,
}
